import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const signes = [
  {
    id: 'signe1',
    img: 'https://readdy.ai/api/search-image?query=Close-up macro photograph of curled and lifted asphalt shingles on a residential roof, edges warped by wind damage, missing granules exposing dark bitumen underneath, Quebec Canadian bungalow roof detail, overcast lighting, authentic documentary photography, warm earthy muted tones, no text, landscape composition 16:9',
    alt: 'Bardeaux soulevés et fendus sur une toiture',
    h3Key: 'signe_1_h3',
    p1Key: 'signe_1_p1',
    p2Key: 'signe_1_p2',
  },
  {
    id: 'signe2',
    img: 'https://readdy.ai/api/search-image?query=Close-up of residential roof gutter filled with black asphalt shingle granules, accumulation of coarse sand-like granules in aluminum gutter, Quebec home exterior detail, overcast autumn day, authentic documentary photography style showing real wear debris, muted tones, no text, landscape composition 16:9',
    alt: 'Granules de bardeaux accumulés dans une gouttière',
    h3Key: 'signe_2_h3',
    p1Key: 'signe_2_p1',
    p2Key: 'signe_2_p2',
  },
  {
    id: 'signe3',
    img: 'https://readdy.ai/api/search-image?query=Water stain on white ceiling of Quebec home interior, yellow-brown discoloration spreading in irregular pattern, water damage from roof leak, residential living room ceiling, natural indoor lighting, authentic documentary photography showing real moisture damage, muted tones, no text, landscape composition 16:9',
    alt: 'Tache deau au plafond causee par une infiltration',
    h3Key: 'signe_3_h3',
    p1Key: 'signe_3_p1',
    p2Key: 'signe_3_p2',
  },
  {
    id: 'signe4',
    img: 'https://readdy.ai/api/search-image?query=Green moss growing thickly on north-facing residential roof shingles, dark green vegetation covering asphalt roof surface, Quebec Canadian home exterior detail, humid overcast day, authentic documentary photography showing organic growth on aging roof, muted natural tones, no text, landscape composition 16:9',
    alt: 'Mousse verte sur les bardeaux dune toiture',
    h3Key: 'signe_4_h3',
    p1Key: 'signe_4_p1',
    p2Key: 'signe_4_p2',
  },
  {
    id: 'signe5',
    img: 'https://readdy.ai/api/search-image?query=Wide angle view of old Quebec residential bungalow with aged asphalt shingle roof showing overall wear and discoloration, 20-year-old roofing with faded color and uneven texture, suburban street of Lévis region, overcast autumn day, authentic documentary photography, muted earth tones, no text, landscape composition 16:9',
    alt: 'Maison avec une toiture vieille de plus de 20 ans',
    h3Key: 'signe_5_h3',
    p1Key: 'signe_5_p1',
    p2Key: 'signe_5_p2',
  },
];

export default function Signes() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="signes" className="scroll-mt-28 space-y-12">
      <h2
        className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {t('signes_h2')}
      </h2>

      <div className="space-y-14 md:space-y-16">
        {signes.map((signe, idx) => {
          const isEven = idx % 2 === 0;
          return (
            <div
              key={signe.id}
              id={signe.id}
              className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-6 lg:gap-8 items-start transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${idx * 120 + 150}ms` }}
            >
              <div className="w-full lg:w-1/2 shrink-0">
                <div className="rounded-xl overflow-hidden">
                  <img
                    src={signe.img}
                    alt={`${signe.alt} — signe de toiture à refaire selon couvreur RBQ à Lévis`}
                    className="w-full h-52 md:h-64 object-cover object-top"
                    loading="lazy"
                    width="800"
                    height="420"
                  />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <span className="inline-block bg-copper/10 text-copper text-xs font-bold tracking-wide uppercase px-2 py-0.5 rounded mb-3">
                  Signe {idx + 1}
                </span>
                <h3 className="font-manrope font-bold text-slate-primary text-lg md:text-xl lg:text-2xl mb-4">
                  {t(signe.h3Key)}
                </h3>
                <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed mb-3">{t(signe.p1Key)}</p>
                <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t(signe.p2Key)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}